import { Table } from 'components/tables/Table';
import { Provider } from 'domain/subscription/interfaces/Subscription';
import React, { useMemo } from 'react';
import { defaultProviderBlacklistTableColumns } from './defaultProviderBlacklistTableColumns';

export const DefaultProviderBlacklistTable: React.FC<{
	blacklistedProviders: Provider[];
	removeProvider: (provider: Provider) => void;
	addedProviders?: Provider[];
	disabled?: boolean;
}> = ({ blacklistedProviders, removeProvider, addedProviders, disabled }) => {
	const columns = useMemo(
		() => [
			defaultProviderBlacklistTableColumns.name(addedProviders),
			defaultProviderBlacklistTableColumns.code(addedProviders),
			defaultProviderBlacklistTableColumns.actions(
				removeProvider,
				disabled,
			),
		],
		[addedProviders, disabled],
	);

	const sortedProviders = useMemo(() => {
		const addedProviderIds = addedProviders?.map((p) => p.id) || [];
		const originalProviders = blacklistedProviders
			.filter((p) => !addedProviderIds.includes(p.id))
			.sort((a, b) => a.name.localeCompare(b.name));

		const addedProvidersList = addedProviders
			? [...addedProviders].sort((a, b) => a.name.localeCompare(b.name))
			: [];

		return [...addedProvidersList, ...originalProviders];
	}, [blacklistedProviders, addedProviders]);

	return (
		<Table<Provider>
			columns={columns}
			data={sortedProviders}
			withPagination={sortedProviders.length > 10}
			withSearch
			showRowCount
		/>
	);
};
